import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class PDQuality {

  #rmp;
  #pdCurrentTime = 0;
  #afterMp4BitrateSwitchFn = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #afterMp4BitrateSwitch(index) {
    this.#rmp.off('srcchanged', this.#afterMp4BitrateSwitchFn);
    this.#rmp.rmpModuleManagement.setActiveLevel('quality', index);
    if (this.#rmp.rmpPlaybackManagement.playerInitialized && this.#pdCurrentTime > -1) {
      Logger.print('info', 'currentTime setter after level change: ' + this.#pdCurrentTime);
      this.#rmp.seekTo(this.#pdCurrentTime).catch(error => {
        this.#rmp.rmpUtils.warning(1016, error);
      });
    }
    this.#rmp.dispatch('qualitychanged');
  }

  destroy() {
    this.#rmp.off('srcchanged', this.#afterMp4BitrateSwitchFn);
  }

  setMp4Bitrate(index, event) {
    FW.eventStopPrevent(event);
    this.#rmp.off('srcchanged', this.#afterMp4BitrateSwitchFn);
    this.#afterMp4BitrateSwitchFn = this.#afterMp4BitrateSwitch.bind(this, index);
    this.#rmp.one('srcchanged', this.#afterMp4BitrateSwitchFn);
    this.#pdCurrentTime = this.#rmp.currentTime;
    this.#rmp.setSrcPDModule = true;
    this.#rmp.dispatch('qualitychanging');
    this.#rmp.setSrc(this.#rmp.src, index).catch(error => {
      this.#rmp.rmpUtils.warning(1025, error);
    });
    this.#rmp.setSrcPDModule = false;
  }

  init() {
    const mp4 = this.#rmp.src.mp4;
    // UI
    this.#rmp.rmpModuleManagement.appendToControlBar('quality');
    this.#rmp.rmpModuleManagement.appendOverlay('quality');
    // append qualities
    for (let i = 0; i < mp4.length; i++) {
      let className;
      let dataSrc;
      if (i === this.#rmp.filteredInitialQuality) {
        className = 'rmp-button rmp-overlay-level rmp-overlay-level-active rmp-color-bg rmp-q' + i;
        dataSrc = mp4[this.#rmp.filteredInitialQuality];
      } else {
        className = 'rmp-button rmp-overlay-level rmp-color-bg rmp-q' + i;
        dataSrc = mp4[i];
      }
      let label;
      if (this.#rmp.customTrackNames.quality.length > 0 && this.#rmp.customTrackNames.quality[i]) {
        label = this.#rmp.customTrackNames.quality[i];
      } else {
        label = `${this.#rmp.labels.hint.quality}  ${(i + 1)}`;
      }
      const newStream = FW.createElement(
        'button',
        className,
        label,
        this.#rmp.rtl,
        true
      );
      newStream.setAttribute('data-src', dataSrc);
      this.#rmp.rmpAccessible.button(newStream, label, true);
      // wire interaction
      const _setMp4BitrateFn = this.setMp4Bitrate.bind(this, i);
      FW.addEvents(['touchend', 'click'], newStream, _setMp4BitrateFn);
      // append new level to UI
      this.#rmp.dom.qualityOverlayLevelsArea.appendChild(newStream);
    }
  }

}
